module.exports = __webpack_public_path__ + "d1dc9b39487109fe73652eeb76cd70fc.svg";